import styled from '@emotion/styled';

export const ExpandWrapper = styled.div`
  margin: ${({ theme }) => `0 0 ${theme.spacing(2)}`};
`;
